export default (context) => {
  const M = "admPublication."
  return {
    config: {
      pageSize: 40,
      list: false,
      resource: "admPublication",
      customPathGet: 'admPublication/get',
      customPathPost: 'admPublication/create',
      enableContexMenu: true
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "type",
          value: "",
          type: "select",
          label: `${M}publicationType`,
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {value: "faq", label: "FAQs"},
              {value: "", label: "main.all"}
            ]
          }
        }
      ],
      buttons: [
        {
          label: 'main.applyFilter',
          renderIf: (ctx) => { return ctx.state.type },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.categoryId = { value: r.data.categoryId, label: r.data.categoryName }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (v.superSections) {
          v.superSections = v.superSections.map(e => {
            e = { ID: e.value, name: e.label, selected: true }
            return e
          })
        }
        if (v.sections) {
          v.sections = v.sections.map(e => {
            e = { ID: e.value, name: e.label, selected: true }
            return e
          })
        }
        delete v.selectedField
        return v
      },
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "hide"
        },
        {
          col: 6,
          name: "name",
          value: "",
          type: "text",
          label: "main.title",
          rules: "required|max:150",
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "categoryId",
          value: "",
          type: "select",
          label: "main.category",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: () => { return "/admCategory/get?type=faq"}
          }
        },      
        {
          col: 12,
          name: "body",
          value: "",
          type: "textarea",
          label: `${M}longComment`,
          rules: "required|max:500",
          opts: {
            style: 'float-label',
            rows: 3
          }
        },
        {
          col: 12,
          name: "published",
          value: true,
          type: "switch",
          label: `${M}publishedVisible`,
        },
        {
          col: 6,
          name: "superSections",
          value: "",
          type: "select",
          label: window.tenant.appName !== 'AppOnCloud' ? `${M}visibleForSuperUnits` : `${M}visibleForGrades`,
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true",
            isMulti: true,
            setOutput: v => v
          },
          renderIf: (ctx) => ctx.state.published
        },
        {
          col: 6,
          name: "sections",
          value: "",
          type: "select",
          label: window.tenant.appName !== 'AppOnCloud' ? `${M}visibleForSubUnits` : `${M}visibleForClasses`,
          parent: 'superSections',
          opts: {
            style: 'float-label',
            path: () => `/admSection/get?pick=true&parentId=${((context.state.form.superSections && context.state.form.superSections.length > 0) ? context.state.form.superSections[0].value : null)}`,
            isMulti: true,
            setOutput: v => v
          },
          renderIf: (ctx) => { return (ctx.state.published &&  ctx.state.superSections?.length === 1) || (ctx.state.published && ctx.state.sections?.length >= 1)}
        },
        {
          col: 12,
          name: "publishFrom", 
          value: new Date().toISOString().split('T')[0],
          type: "hide"
        },
        {
          col: 12,
          name: "publishTo",
          value: new Date().toISOString().split('T')[0],
          type: "hide"
        },
      ]  
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: `${M}publishedVisible`,
        accessor: "published",
        isBool: true
      }
    ]
  }
}